import C from '../constants';


export const changeAuthorized = statusLoad => {
    return {
        type: C.CHANGE_AUTHORIZED,
        statusLoad: statusLoad,
    }
};






// WEBPACK FOOTER //
// src/actions/auth.jsx